'use strict';
const angular = require('angular');

export class galleriesWidgetComponent {

  constructor(GalleryService) {
    'ngInject';

    this.GalleryService = GalleryService;
  }

  getPreviewText(text) {
    return text ? String(text).replace(/<[^>]+>/gm, ' ').substr(0, 150) + '...' : '';
  }

  $onInit() {
    this.GalleryService.getNewest({count:this.count || 3}, data => {
      this.data = data;
    }, err => {
      console.log('could not retrieve newest galleries');
    });
  }
}

export default angular.module('conduuApp.galleriesWidget', [])
  .component('galleriesWidget', {
    template: require('./galleries-widget.component.html'),
    bindings: {
      count: '@'
    },
    controller: galleriesWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/galleries-widget/galleries-widget.component.js